export default "__VITE_ASSET__DRFNBJvn__";